import {FC} from "react";
import {ITypeRadar} from "../../../types";
import {SidebarTab} from "../../Sidebar";
import {
  IClusterDataFromServer,
  IClusterDataSideBar,
  IClustersMolecule,
  ITehnologiesDataFromServer,
  ITehnologyDataSideBar,
} from "../../../pages/Dashboard/Dashboard.type";
import {SideBarContentMapDirection} from "./SideBarContentMapDirection";
import {SideBarContentMapClusters} from "./SideBarContentMapClusters";
import {SideBarContentMapTehnologie} from "./SideBarContentMapTehnologie";

interface IProps {
  idMoleculeActive: number;
  clusterIdOnTehnologie: number;
  dataDirection: any | undefined;
  typeRadar: ITypeRadar;
  activeTab: string;
  dataCluster: IClusterDataFromServer | undefined;
  cpuStep: number;
  dataTechnology?: ITehnologiesDataFromServer | undefined;
  handleCardClick: (id: number | string, name: string) => void;
  handleSecondStepCpu: (id: string) => void;

  sortOption: any;
  handleSortTitle: any;
  handleSort: any;
  // dataCurrentMolecula: IClustersMolecule | undefined;
  titleCluster: string;
  colorTitle?: string;
  technologieId?: number | string | null;
  setIsShowCharts: (value: boolean) => void;
  isShowCharts: boolean;
}

export const SideBarContentMap: FC<IProps> = ({
  idMoleculeActive,
  clusterIdOnTehnologie,
  dataDirection,
  typeRadar,
  activeTab,
  dataCluster,
  cpuStep,
  dataTechnology,
  handleCardClick,
  handleSecondStepCpu,
  sortOption,
  handleSortTitle,
  handleSort,
  // dataCurrentMolecula,
  titleCluster,
  colorTitle,
  technologieId,
  setIsShowCharts,
  isShowCharts,
}) => {
  return (
    <>
      {activeTab === SidebarTab.Clusters ? (
        <SideBarContentMapDirection
          dataDirection={dataDirection}
          typeRadar={typeRadar}
          handleCardClick={handleCardClick}
          activeTab={activeTab}
          cpuStep={cpuStep}
          sortOption={sortOption}
          handleSortTitle={handleSortTitle}
          handleSort={handleSort}
          colorTitle={colorTitle}
          setIsShowCharts={setIsShowCharts}
          isShowCharts={isShowCharts}
        />
      ) : activeTab === SidebarTab.CPU && cpuStep === 1 ? (
        <SideBarContentMapClusters
          dataCluster={dataCluster}
          typeRadar={typeRadar}
          handleSecondStepCpu={handleSecondStepCpu}
          handleSortTitle={handleSortTitle}
          handleSort={handleSort}
          sortOption={sortOption}
          colorTitle={colorTitle}
          titleCluster={titleCluster}
          setIsShowCharts={setIsShowCharts}
          isShowCharts={isShowCharts}
        />
      ) : (
        <SideBarContentMapTehnologie
          dataTehnology={dataTechnology}
          dataCluster={dataCluster}
          typeRadar={typeRadar}
          // dataCurrentMolecula={dataCurrentMolecula}
          idMoleculeActive={idMoleculeActive}
          colorTitle={colorTitle}
          technologieId={technologieId}
          clusterIdOnTehnologie={clusterIdOnTehnologie}
          setIsShowCharts={setIsShowCharts}
          isShowCharts={isShowCharts}
        />
      )}
    </>
  );
};
